<template>
<div>
  <error :error="error"/>
  <div id='params' class="container dsr_box" v-if="!error">
    <form>
      <h1 class="text-primary">Device configuration</h1>
    
      <div class="form-group" v-if="searching === false">
        <label class="text-secondary">Device id</label>
        <input type="text" class="form-control" id="uuid" :value="id" disabled>
      </div>

      <div class="form-group" v-if="searching === false">
        <label class="text-secondary">Brand</label>
        <div class="d-block btn-group" data-toggle="buttons">
          <brand-button  v-for="brandL in brands" :key="brandL.get('data').name | capitalize" :current="brand" :brand="brandL" @click="setBrand"></brand-button>
        </div>
      </div>

      <div v-if="brand">
        <div class="form-group" @click="searching = true">
          <label class="text-secondary">Site</label>
          <v-select  :searchable="true" v-model="site" :options="sites" class='select' :onChange="siteChanged">
            <span slot="no-options">Pas de résultats.</span>
          </v-select>
        </div>

        <div class="form-group">
          <label class="text-secondary">Screen type</label>
           <v-select :searchable="false" v-model="screenType" :options="screenTypes" :getOptionLabel="getScreenTypeName" label="id" class='select'></v-select>
        </div>

        <div class="form-group" v-if="screenType">
          <label class="text-secondary">Template</label>
          <v-select :searchable="false" v-model="template" :options="templates" :getOptionLabel="getTemplateName" label="id" class='select'></v-select>
        </div>
      </div>
      <button id='save' class="btn btn-primary btn-lg float-right" @click.prevent="saveParams">Save</button>
    </form>
  </div>
</div>
</template>

<script>
import BrandButton from './BrandButton'
import vSelect from 'vue-select'
import Error from '../error/error'
var remove = require('lodash/remove')

export default {
  name: 'ConfForm',
  components: {
    BrandButton,
    vSelect,
    Error
  },
  data () {
    return {
      brands: [],
      brand: null,
      sites: [],
      site: null,
      screenTypes: [],
      screenType: null,
      templates: [],
      template: null,
      error: null,
      searching: false
    }
  },
  methods: {
    getData () {
      this.getBrands()
      this.getScreenTypes()
    },
    getBrands () {
      this.$vueParse.brand.getAll().find()
      .then(brands => {
        this.brands = brands
      })
    },
    formatSites (sites) {
      for (let i = 0; i < sites.length; i++) {  // Format array to be serachable in vue-select
        sites[i].label = sites[i].get('data').code
      }
      remove(sites, function (site) { // remove elements without label
        return !site.label
      })
      return sites
    },
    getSites () {
      this.$vueParse.site.getByBrand(this.brand).find()
      .then(sites => {
        this.sites = this.formatSites(sites)
      })
    },
    getScreenTypes () {
      this.$vueParse.screenType.getAll().find()
      .then(screenTypes => {
        this.screenTypes = screenTypes
      })
    },
    getTemplates () {
      this.$vueParse.template.getByBrandAndScreenType(this.brand, this.screenType).find()
      .then(templates => {
        this.templates = templates
      })
    },
    setBrand (brand) {
      this.brand = brand
    },
    saveParams () {
      console.log('saveParams')
      if (this.site === null || this.brand === null || this.template == null) {
        return // dont redirect if some fields are empty
      }

      if (!this.device) {
        console.log('Creating new device')
        this.$vueParse.device.set(this.id, this.user, this.site, this.template)
        .then(device => {
          console.log('New device created', device)
          this.redirect()
        })
        .catch(error => {
          console.log('Error creating device', error)
        })
      } else {
        console.log('Updating device')
        this.device.set('site', this.site)
        this.device.set('template', this.template)
        this.device.save()
        .then(device => {
          console.log('Device updated', device)
          this.redirect()
        })
        .catch(error => {
          console.log('Error updating device', error)
        })
      }
    },
    redirect () {
      this.$router.push({name: 'Redirect', query: this.$route.query})
    },
    /** fill form with device data */
    fillForm (device) {
      this.sites = this.sites = this.formatSites([device.get('site')])
      this.site = this.sites[0]
      this.brand = this.site.get('brand')
      this.template = device.get('template')
      this.screenType = this.template.get('screenType')
    },
    getScreenTypeName (screenType) {
      var value = screenType.get('data').name
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    getTemplateName (template) {
      return template.get('data').name
    },
    siteChanged (site) {
      console.log('Site changed')
      this.searching = false
      this.site = site
    }
  },
  watch: {
    brand (value) {
      this.getSites()
    },
    screenType (value) {
      this.getTemplates()
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  computed: {
    id () {
      return this.$route.query.deviceId
    },
    device () {
      return this.$store.state.device
    },
    user () {
      return this.$store.getters.user
    }
  },
  mounted () {
    if (!this.id) {
      this.error = {title: 'Error', message: 'Device id required'}
    } else {
      this.$vueParse.Parse.Cloud.run('deviceExists', { id: this.id })
      .then(exists => {
        if (exists) {
          if (!this.user) {
            this.error = {title: 'Authentication required', message: ''}
          }

          this.getData()
          this.$dm.setDevice().then(device => {
            this.fillForm(device)
          })
          .catch(error => {
            console.log(error.message)
            // this.error = {title: error.message, message: 'Check your permissions'}
          })
        } else {
          // If user exists we must authenticate as this user
          var query = new this.$vueParse.Parse.Query(this.$vueParse.Parse.User)
          query.equalTo('username', `Device_${this.id}`)
          query.first().then((user) => {
            if (user) {
              if (this.user && (this.user.id === user.id)) {
                this.getData()
              } else {
                this.error = {title: 'Authentication required', message: 'User already exists'}
              }
            } else { // User dont exists, we can create it
              this.$authManager.signUp().then(user => {
                this.getData()
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style lang='scss'>
@import '../../../scss/global.scss';

#app {
   @extend .gradientBackground;
}

input  {
  font-size: 1.5rem!important;
  height: 4rem!important;
}

label {
  font-size: 1.3rem;
}

.v-select {
  font-size: 1.5rem;
  height: 4rem;

  .open-indicator {
    height: 2rem!important;
  }

  .dropdown-toggle {
    height: 4rem;
    background-color: white!important;

    .selected-tag {
      height: 3.5rem;
      line-height: 3rem;
    }
  }

  .dropdown-menu {
    a {
      height: 60px;
      line-height: 60px;
    }
  }
}

#params {
  padding-bottom: 90px;
  width: 90vw;
  height: 90vh;

  #save {
    float: right!important;
    width: 15vw;
    height: 6vh;
  }
}

</style>




// WEBPACK FOOTER //
// src/components/params/params.vue